var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      ref: "textareaContainer",
      staticClass: "s2-textarea-container",
      class: { "listening-active": _vm.isListening },
    },
    [
      _c(
        "a-textarea",
        _vm._g(
          _vm._b(
            {
              ref: "textarea",
              model: {
                value: _vm.cloneValue,
                callback: function ($$v) {
                  _vm.cloneValue = $$v
                },
                expression: "cloneValue",
              },
            },
            "a-textarea",
            _vm.filteredAttrs,
            false
          ),
          _vm.filteredListeners
        )
      ),
      _vm._v(" "),
      _vm.aiCopilot
        ? _c("AICopilot", {
            attrs: { payload: _vm.aiCopilot, type: "message" },
            on: {
              close: function ($event) {
                _vm.aiCopilot = null
              },
              change: _vm.updateTextFromAI,
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "action-buttons" }, [
        _vm.showAITool
          ? _c(
              "div",
              { staticClass: "ai-button", on: { click: _vm.openAICopilot } },
              [
                _c("img", {
                  attrs: {
                    src: "/static/img/copilot.png",
                    width: "20",
                    height: "20",
                  },
                }),
              ]
            )
          : _vm._e(),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "mic-button",
            class: { active: _vm.isListening },
            on: {
              click: function () {
                return _vm.isListening
                  ? _vm.stopListening("mic-button")
                  : _vm.startListening()
              },
            },
          },
          [
            _c("a-icon", { attrs: { type: "audio", theme: "filled" } }),
            _vm._v(" "),
            _vm.isListening
              ? _c("span", [_vm._v(_vm._s(_vm.$t("message.speakNow")))])
              : _vm._e(),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _vm.showShortcutHint || _vm.isListening
        ? _c(
            "div",
            { staticClass: "voice-shortcut-hint" },
            [
              _vm.isListening
                ? [
                    _vm._m(0),
                    _vm._v(" "),
                    _c("div", { staticClass: "listening-text" }, [
                      _c("span", [
                        _vm._v(_vm._s(_vm.$t("message.listeningInProgress"))),
                      ]),
                      _vm._v(" "),
                      _c("small", [
                        _vm._v(_vm._s(_vm.$t("message.spaceKeyReleaseToSave"))),
                      ]),
                    ]),
                  ]
                : [
                    _c("a-icon", { attrs: { type: "keyboard" } }),
                    _vm._v(" "),
                    _c("span", [
                      _vm._v(_vm._s(_vm.$t("message.spaceKeyHint"))),
                    ]),
                  ],
            ],
            2
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.speechSupported === false
        ? _c("p", { staticClass: "speech-not-supported" }, [
            _vm._v(
              "\n        " +
                _vm._s(_vm.$t("message.browserSpeechRecognitionNotSupported")) +
                "\n    "
            ),
          ])
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "listening-waves" }, [
      _c("span"),
      _vm._v(" "),
      _c("span"),
      _vm._v(" "),
      _c("span"),
      _vm._v(" "),
      _c("span"),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }